import { render, staticRenderFns } from "./PreRegisterCampaign.vue?vue&type=template&id=06b7ac1b&scoped=true"
import script from "./PreRegisterCampaign.vue?vue&type=script&lang=js"
export * from "./PreRegisterCampaign.vue?vue&type=script&lang=js"
import style0 from "./PreRegisterCampaign.vue?vue&type=style&index=0&id=06b7ac1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7ac1b",
  null
  
)

export default component.exports